import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import {Dialogs} from "@ionic-native/dialogs";
import {SMS} from "@ionic-native/sms";
//import { SMS } from '@awesome-cordova-plugins/sms/ngx';
import { BackgroundMode } from '@ionic-native/background-mode';
import { LocalNotifications } from '@ionic-native/local-notifications';
import {Network} from "@ionic-native/network";

import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import {AssetsPage} from "../pages/assets/assets";
import {AssetsService} from "../services/assets.service";
import {IonicStorageModule} from "@ionic/storage";
import {HttpModule} from "@angular/http";
import {FleetsService} from "../services/fleets.service";
import {DevicesService} from "../services/devices.service";
import {DeviceMsgService} from "../services/deviceMsg.service";
import {HttpInterceptor2} from "../services/HttpInterceptor.service";
import {CompaniesService} from "../services/companies.service";
import {AuthService} from "../services/auth.service";
import {MainPage} from "../pages/main/main";
import {AlertsService} from "../services/alerts.service";
import {DriversService} from "../services/drivers.service";
import {UtilsService} from "../services/utils.service";
import {RealtimePage} from "../pages/realtime/realtime";
import {HistoricPage} from "../pages/historic/historic";
import {SensorUtilService} from "../services/sensors.service";
import {AlertsPage} from "../pages/alerts/alerts";
import {SplashPage} from "../pages/splash/splash";
import {SocketService} from "../services/socket.service";
import {TruncatePipe} from "../filters/limitto.filter";
import {MomentPipe} from "../filters/ago.filter";
import {NetworkService} from "../services/network.service";
import {CompaniesModal} from "../pages/modals/companies/companies.modal";
import {FleetsModal} from "../pages/modals/fleets/fleets.modal";
import {RealtimeMultiPage} from "../pages/realtime/realtime.multi";

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    AssetsPage,
    MainPage,
    RealtimePage,
    AlertsPage,
    HistoricPage,
    SplashPage,
    RealtimeMultiPage,
    TruncatePipe,
    MomentPipe,
    CompaniesModal,
    FleetsModal

  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {tabsPlacement: 'bottom'}),
    IonicStorageModule.forRoot({
      name: '__tcfleet',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    AssetsPage,
    MainPage,
    RealtimePage,
    HistoricPage,
    AlertsPage,
    SplashPage,
    RealtimeMultiPage,
    CompaniesModal,
    FleetsModal
  ],
  providers: [
    StatusBar,
    Dialogs,
    HttpInterceptor2,
    AuthService,
    AlertsService,
    DriversService,
    UtilsService,
    SensorUtilService,
    AssetsService,
    FleetsService,
    DevicesService,
    DeviceMsgService,
    CompaniesService,
    SocketService,
    NetworkService,
    Network,
    SMS,
    BackgroundMode,
    LocalNotifications,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts